import React from 'react';
import Row from "../../../../SDFormTemplate/Row";
import Accordion from 'components/Common/Accordion/Accordion';
import CustomSection from '../../../../SDFormTemplate/CustomSection';
import NewGroupTree from './NewGroupTree';

// new group tree component - encapsulated inside wrapper
const GroupTree = ({ totalGroups, setFormData, availableGroups, setAvailableGroups }) => {
  return (
    <NewGroupTree newGroups={totalGroups} setFormData={setFormData} availableGroups={availableGroups} setAvailableGroups={setAvailableGroups} />
  )
}

function Groups({ setInvalidConditions, setFormData, setAvailableGroups }) {
  
  const title = 'Groups';

  const groupTreeWrapper = () => {
    return (
      <CustomSection
        key='custom_group_component'
        customContent={
          <GroupTree 
            key='group_tree_component'
            setFormData={setFormData} 
            setAvailableGroups={setAvailableGroups} 
          />
        }
        setFormData={setFormData}
        setInvalidConditions={setInvalidConditions} 
        setAvailableGroups={setAvailableGroups}
      />
    )
  }

  return (
    <div key="groups">
      <Row
        key='row_2'
        sections={[
          (index) => (
            <Accordion
              key='accordion_2'
              title={title}
              accordionHeaderSection={true}
              accordionHeaderContents={{
                size: 'md',
                message: 'Create the group structure with groups and subgroups - All Sites will be applied as standard.',
              }}
              showNumberInHeader={false}
              headerNumber={index + 1}
              content={[
                groupTreeWrapper(),
                // <span className='d-flex justify-content-end'>
                //   <Tooltip
                //     description='Skipping this section will add any new enterprise sites during this process to the "All Sites" group'
                //     placement='top'
                //   >
                //     <Button
                //       variant='warning'
                //       // onClick={() => console.log('test')
                //     >
                //       Skip for now
                //     </Button>
                //   </Tooltip>
                // </span>,
              ]}
            />
          )
        ]}
      />
    </div>
  )
}

export default Groups;
